import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const CanonicalLink: React.FC = () => {
  const { origin, pathname } = useSelector(select.location.get);

  return (
    <Helmet>
      <link rel="canonical" href={`${origin}${pathname}`} />
    </Helmet>
  );
};

export default CanonicalLink;
